import { render, staticRenderFns } from "./BaseAccordionDrilldown.vue?vue&type=template&id=627a165d"
import script from "./BaseAccordionDrilldown.vue?vue&type=script&lang=js"
export * from "./BaseAccordionDrilldown.vue?vue&type=script&lang=js"
import style0 from "./BaseAccordionDrilldown.vue?vue&type=style&index=0&id=627a165d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports